module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    style: (_vm.bannerFlag ? 'margin-top: 45px;' : '')
  }, [(!_vm.error) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "min-height": "calc(100vh - 106px)"
    },
    attrs: {
      "element-loading-text": "加载中..."
    }
  }, [_c('div', {
    staticClass: "banner w"
  }, [_c('div', {
    ref: "bg",
    staticClass: "bg",
    on: {
      "mouseover": function($event) {
        return _vm.bgOver(_vm.$refs.bg)
      },
      "mousemove": function($event) {
        return _vm.bgMove(_vm.$refs.bg, $event)
      },
      "mouseout": function($event) {
        return _vm.bgOut(_vm.$refs.bg)
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "activity-panel w"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.catalogList), function(item, j) {
    return _c('li', {
      key: j,
      staticClass: "content",
      on: {
        "click": function($event) {
          return _vm.linkToCatalog(j)
        }
      }
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.iconSelect
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "22px",
        "margin-top": "-5px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "cover-link"
    })])
  }), 0)]), _vm._v(" "), _c('section', {
    staticClass: "news-panel w"
  }, [_c('div', {
    staticClass: "new-panel-box",
    attrs: {
      "id": "home"
    },
    on: {
      "click": function($event) {
        return _vm.onAiDesign()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": "https://yxzrz.oss-cn-beijing.aliyuncs.com/Public/match/aibg.png"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "link-panel w"
  }, [_c('h1', [_vm._v("服务专区")]), _vm._v(" "), _c('div', {
    staticClass: "link-box"
  }, [_c('ul', _vm._l((_vm.cataList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "box-li",
      on: {
        "click": function($event) {
          return _vm.openAgree(item.id)
        }
      }
    }, [_c('i', {
      class: item.icon
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.item))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "no-info"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "header-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px 20px"
    }
  }, [_vm._v("认证申请")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around",
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "item itme1"
  }, [_c('a', {
    on: {
      "click": _vm.factory
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("诊所/工厂认证")])])]), _vm._v(" "), _c('div', {
    staticClass: "item itme2"
  }, [_c('a', {
    on: {
      "click": _vm.designer
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("设计师认证")])])])])]), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  }), _vm._v(" "), _c('tools', {
    staticClass: "tools",
    staticStyle: {
      "display": "block"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h1', [_vm._v("Online设计服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mall-panel w",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('div', {
    staticClass: "mall-panel-box"
  }, [_c('ul', {
    staticClass: "left-box"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/error.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 抱歉！出错了...\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625a018b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/home.vue
// module id = 651
// module chunks = 0